import React from 'react';
import '../../styles/Homepage.css';
import '../../styles/Fonts.css';
import 'bootstrap/dist/css/bootstrap.min.css';
import '@fortawesome/fontawesome-free/css/all.min.css';

const CargoManagement = () => {
  return (
    <section id="services-preview" className="services-preview-section">
      <div className="container">
        <div className="section-header">
          <div className="section-badge">OUR SOLUTIONS</div>
          <h2 className="section-title">Cargo Management Solutions</h2>
          <p className="section-description">
            Comprehensive logistics solutions designed to streamline your supply chain and optimize operations.
          </p>
        </div>

        <div className="services-cards-grid">
          <div className="service-card">
            <div className="service-card-icon">
              <i className="fas fa-user-cog"></i>
            </div>
            <h3 className="service-card-title">Personalized Approach</h3>
            <p className="service-card-description">
              Tailored logistics strategies optimize your supply chain from start to end.
            </p>
          </div>

          <div className="service-card">
            <div className="service-card-icon">
              <i className="fas fa-route"></i>
            </div>
            <h3 className="service-card-title">End-to-End Efficiency</h3>
            <p className="service-card-description">
              Real-time tracking ensures smooth cargo movement and peace of mind.
            </p>
          </div>

          <div className="service-card">
            <div className="service-card-icon">
              <i className="fas fa-dollar-sign"></i>
            </div>
            <h3 className="service-card-title">Cost-Efficiency</h3>
            <p className="service-card-description">
              Custom services optimize routes and modes, saving time and money.
            </p>
          </div>

          <div className="service-card">
            <div className="service-card-icon">
              <i className="fas fa-headset"></i>
            </div>
            <h3 className="service-card-title">Expert Support</h3>
            <p className="service-card-description">
              Our experts provide 24/7 support and adjust logistics plans.
            </p>
          </div>

          <div className="service-card">
            <div className="service-card-icon">
              <i className="fas fa-globe"></i>
            </div>
            <h3 className="service-card-title">Global Reach</h3>
            <p className="service-card-description">
              Our global network delivers top-tier service with local insight.
            </p>
          </div>

          <div className="service-card">
            <div className="service-card-icon">
              <i className="fas fa-shield-alt"></i>
            </div>
            <h3 className="service-card-title">Secure Handling</h3>
            <p className="service-card-description">
              Advanced security protocols ensure safe transport of your valuable cargo.
            </p>
          </div>
        </div>
      </div>
    </section>
  );
};

export default CargoManagement;